module.exports = "/assets/js/a221147d26aed02532034e058621324f.svg";